/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const subscriptionSchema = z.object({
  id: z.string(),
  userId: z.string(),
  planKey: z.string(),
  status: z.string(),
  platform: z.string(),
  originalTransactionId: z.string(),
  latestTransactionId: z.string().nullable(),
  purchaseDate: z.number(),
  expiresDate: z.number().nullable(),
  cancelledDate: z.number().nullable(),
  autoRenewing: z.number(),
  gracePeriodExpiresDate: z.number().nullable(),
  environment: z.string(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type ISubscription = z.infer<typeof subscriptionSchema>;
